<div id="dummy-back"></div>
<div id="loader-wrapper" class="bmo-loading ultramarine">
  <img src="/assets/icons/loading.svg" />
</div>
